// extracted by mini-css-extract-plugin
export default {"page":"BestiaryListPage_page__9Rz+A","block":"BestiaryListPage_block__Cgc5e","list":"BestiaryListPage_list__8Fo9q","info":"BestiaryListPage_info__bcP9v"};